import {apiPost} from "./General";

export const formSubmit = (body, cb, ecb) => {
    apiPost('users/contactus', body, cb, ecb);
}

export const enterpriseContactUsSubmit = (body, cb, ecb) => {
    apiPost('users/contactus', body, cb, ecb, true);
}
